import { Box, IconButton } from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import React from 'react';

interface HeaderProps {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
}
export default function Header({ isSidebarOpen, toggleSidebar }: HeaderProps) {
  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: 1 }}>
      <IconButton onClick={() => toggleSidebar()}>
        <MenuOpenIcon sx={{ transform: isSidebarOpen ? 'rotate(0deg)' : 'rotate(180deg)', transition: 'transform 0.3s ease-in-out' }} />
      </IconButton>
    </Box>
  );
}
